module.exports = __webpack_public_path__ + "media/application/images/section_images/projects-54bdc52f26aead4c00819ed54e0c83c5.jpg";